import { render, staticRenderFns } from "./WatchDemo.vue?vue&type=template&id=20eb2322&"
import script from "./WatchDemo.vue?vue&type=script&lang=js&"
export * from "./WatchDemo.vue?vue&type=script&lang=js&"
import style0 from "./WatchDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports